import React from "react";

const CustomSection = ({ children, className }) => {
  return <div className={`flex gap-1 ${className}`}>{children}</div>;
};

export default CustomSection;
